import "./Cart.module.css";
import AutoMotiGalvene from "@/reusable_sections/Header";
import CartContent from "./sections/CartContent";
import Footer from "@/reusable_sections/Footer";
export default function CartPage() {
  return <div>
      <AutoMotiGalvene />
      <CartContent />
      <Footer />
    </div>;
}